/**
 * Parse time in seconds from a duration string
 */
export const parseTime = (time: string) => {
    return time
        .trim()
        .split(":")
        .reverse()
        .reduce(
            function (result: number, part, index: number) {
                return result + parseInt(part || "0", 10) * Math.pow(60, index);
            },
            0
        );
};

/**
 * pad stringified numbers with zeros
 */
const padWithZero = (num: number) => {
    num = num || 0;
    return num < 10 ? "0" + num : num;
};

/**
 * Convert time in seconds to a duration string
 */
export const stringifyTime = (time: number) => {
    const rounded = Math.round(time);
    const h = padWithZero(Math.floor(rounded / 3600));
    const m = padWithZero(Math.floor((rounded / 60) % 60));
    const s = padWithZero(rounded % 60);

    return [h, m, s].join(":");
};
